<template>
  <div v-if="photo && photo.id">
    <v-container v-if="photoDetailsVisible" fluid class="pa-0">
      <v-container :class="{ 'py-5': !dense, 'pa-0 mb-4': dense }">
        <v-row no-gutters>
          <v-col
            v-if="photo.statusName !== types.photo.status.inCuration"
            :class="{ 'mb-4': $vuetify.breakpoint.smAndDown }"
            :md="dense ? 12 : 6"
            class="pa-0"
          >
            <v-row no-gutters>
              <div>
                <client-only>
                  <vue-goodshare-facebook
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                  <vue-goodshare-twitter
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                  <vue-goodshare-vkontakte
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                  <vue-goodshare-linkedin
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                  <vue-goodshare-pinterest
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                  <vue-goodshare-reddit
                    :page_url="`https://100asa.com/photo/${photo.id}/${photo.slug}/`"
                    :page_image="photo.thumbnailUrl"
                    :page_title="photo.title"
                    :page_description="photo.description"
                    :hashtag="
                      photo.tags.length ? photo.tags.toString() : '100ASA'
                    "
                    has_icon
                  />
                </client-only>
              </div>
            </v-row>
          </v-col>
          <v-col
            :md="
              dense || photo.statusName === types.photo.status.inCuration
                ? 12
                : 6
            "
            cols="12"
            class="pa-0 text-right"
            align-self="center"
          >
            <v-row class="justify-space-between align-center" no-gutters>
              <div v-if="me">
                <span v-if="showTokens">
                  <v-icon small color="gold">fal fa-coins</v-icon>
                  <span class="text-body-2 rep ml-1">{{
                    me.userTokens ? me.userTokens.toLocaleString() : 0
                  }}</span>
                </span>
              </div>
              <div class="d-flex justify-end">
                <span>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        :disabled="likePhotoBusy"
                        :loading="likePhotoBusy"
                        :outlined="!info || !info.isLiked"
                        class="ml-4"
                        fab
                        depressed
                        small
                        v-on="on"
                        @click="
                          likePhoto(
                            $event,
                            info && info.isLiked ? -1 : 1,
                            photo.id,
                            photo.photographerId,
                            'photo'
                          )
                        "
                      >
                        <div>
                          <v-icon dark small
                            >{{
                              info && info.isLiked ? 'fas' : 'fal'
                            }}
                            fa-heart</v-icon
                          >
                        </div>
                      </v-btn>
                      <span class="ml-2">
                        {{ photo.numberOfLikes }}
                      </span>
                    </template>
                    <span>
                      {{ info && info.isLiked ? 'Unlike' : 'Like' }} this photo
                    </span>
                  </v-tooltip>
                </span>
                <span
                  v-if="
                    photo.statusName !== types.photo.status.inCuration &&
                      photo.statusName !== types.photo.status.elite &&
                      photo.statusName !== types.photo.status.inspiration &&
                      (!me ||
                    (me &&
                      me.id !== photo.photographerId &&
                      me.role !== types.user.role.curator))
                  "
                >
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        :disabled="nominatePhotoBusy"
                        :loading="nominatePhotoBusy"
                        outlined
                        class="ml-4"
                        fab
                        depressed
                        small
                        v-on="on"
                        @click="nominatePhoto($event, photo)"
                      >
                        <div>
                          <v-icon dark small>
                            fal fa-lightbulb-on
                          </v-icon>
                        </div>
                      </v-btn>
                    </template>
                    <span>
                      Nominate this photo
                    </span>
                  </v-tooltip>
                </span>
                <span v-if="photo.statusName !== types.photo.status.inCuration">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        outlined
                        class="ml-4"
                        fab
                        depressed
                        small
                        v-on="on"
                        @click="openAddToGalleryDialog($event, photo)"
                      >
                        <div>
                          <v-icon dark small> fal fa-layer-plus </v-icon>
                        </div>
                      </v-btn>
                    </template>
                    <span> Add this photo to your galleries </span>
                  </v-tooltip>
                </span>
                <v-tooltip v-if="me" bottom>
                  <template #activator="{ on }">
                    <v-btn
                      class="ml-4"
                      fab
                      depressed
                      outlined
                      small
                      v-on="on"
                      @click="reportPhoto()"
                    >
                      <v-icon dark small>fal fa-flag</v-icon>
                    </v-btn>
                  </template>
                  <span>Report this photo</span>
                </v-tooltip>

                <v-menu
                  v-if="
                    me &&
                    (me.isEditor ||
                      me.isAdmin ||
                      me.role === types.user.role.curator)
                  "
                  :close-on-content-click="false"
                  left
                  bottom
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      fab
                      dark
                      icon
                      small
                      class="bluezone ml-4"
                      v-on="on"
                    >
                      <v-icon small> fal fa-ellipsis-v </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <!-- Download Editor photo -->
                    <v-list-item
                      @click="downloadEditorPhoto($event, photo, false)"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon small>fal fa-cloud-download-alt</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          Download photo
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- Vote for Elite -->
                    <v-list-item
                      v-if="
                        (photo.statusName === types.photo.status.prime ||
                          photo.statusName ===
                            types.photo.status.inspiration) &&
                        me &&
                        me.id !== photo.photographerId &&
                        (me.role === types.user.role.curator || me.isAdmin)
                      "
                      :disabled="promoteElitePhotoBusy"
                      @click="promoteElitePhoto"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon small>
                          {{ promoteElitePhotoBusy || !info.isVoteToPromoteElite ? 'fal' : 'fas' }} fa-{{ promoteElitePhotoBusy ? 'spinner fa-spin' : 'star' }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ info.isVoteToPromoteElite ? 'Downvote' : 'Vote' }} for Elite
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- Vote for Inspiration -->
                    <v-list-item
                      v-if="
                        (photo.statusName === types.photo.status.prime || photo.isNominated) &&
                        me &&
                        me.id !== photo.photographerId &&
                        (me.role === types.user.role.curator || me.isAdmin)
                      "
                      :disabled="promoteInspirationPhotoBusy"
                      @click="promoteInspirationPhoto"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon small
                          >fal fa-{{
                            promoteInspirationPhotoBusy
                              ? 'spinner fa-spin'
                              : 'lightbulb-on'
                          }}</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          Vote for Inspiration
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- Promote to Prime -->
                    <v-list-item
                      v-if="
                        photo.statusName === types.photo.status.upcoming &&
                        me &&
                        me.id !== photo.photographerId &&
                        (me.role === types.user.role.curator || me.isAdmin)
                      "
                      :disabled="promoteUpcomingPhotoBusy"
                      @click="promoteUpcomingPhoto"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon small
                          >fal fa-{{
                            promoteUpcomingPhotoBusy
                              ? 'spinner fa-spin'
                              : 'arrow-circle-up'
                          }}</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          Promote to Prime
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <!-- Edit photo -->
                    <Edit-photo-dialog
                      v-if="
                        photo.categoryId &&
                        me &&
                        (me.isAdmin || me.role === types.user.role.curator)
                      "
                      :photo="photo"
                      :categories="categories"
                      :is-admin="true"
                    />
                    <!-- Remove photo -->
                    <v-list-item v-if="me && me.isAdmin" @click="removePhoto">
                      <v-list-item-icon class="mr-3">
                        <v-icon small class="error--text"
                          >fal fa-trash-alt</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold error--text">
                          Remove this photo
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Galleries-dialog />
  </div>
</template>

<script>


import { mapState } from 'vuex'
import types from '@/utils/types'
import { displayConfirm } from '@/utils/swal'
import { likePhotoMixin } from '@/mixins/likePhotoMixin'
import { nominatePhotoMixin } from '@/mixins/nominatePhotoMixin'
import { editorsMixin } from '@/mixins/editorsMixin'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'PhotoActions',
  components: {
    EditPhotoDialog: () =>
      import('@/components/account/photos/EditPhotoDialog.vue'),
    GalleriesDialog: () => import('@/components/galleries/GalleriesDialog.vue')
  },
  mixins: [likePhotoMixin, nominatePhotoMixin, editorsMixin],
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    },
    info: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: false
    },
    goBack: {
      type: Function,
      default: () => {}
    },
    showTokens: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      types,
      promoteElitePhotoBusy: false,
      promoteInspirationPhotoBusy: false,
      promoteUpcomingPhotoBusy: false,
      photoDetailsVisible: true,
      socialDialog: false
    }
  },
  computed: {
    ...mapState({
      errorMessage: state => state.photos.errorMessage
    })
  },
  mounted() {
    EventBus.$on('arePhotoDetailsVisible', photoDetailsVisible => {
      this.photoDetailsVisible = photoDetailsVisible
    })
  },
  methods: {
    openAddToGalleryDialog(event, photo) {
      event.preventDefault()
      this.$store.dispatch('galleries/setSelectedPhotoToAdd', photo)
      this.$store.dispatch('galleries/setAddPhotoToGalleryDialogVisible', true)
    },
    async promoteElitePhoto() {
      this.promoteElitePhotoBusy = true
      try {
        const id = this.photo.id
        const alreadyVoted = this.info.isVoteToPromoteElite
        if (alreadyVoted) {
          await this.$store.dispatch('photos/downvotePromoteElite', id)
        } else {
          await this.$store.dispatch('photos/promoteElite', id)
        }
        EventBus.$emit('snackbar', {
          text: this.errorMessage
            ? this.errorMessage
            : `You've successfully ${ alreadyVoted ? 'downvoted' : 'voted' } to promote this photo to the Elite gallery`,
          color: this.errorMessage ? 'info' : 'success'
        })
        await this.$store.dispatch('photos/getInfo', id)
        await this.$auth.fetchUser()
      } catch (error) {
        this.$asa.appInsights('Comp: photo/Actions.vue - method: promoteElitePhoto', error)
      } finally {
        this.promoteElitePhotoBusy = false
      }
    },
    async promoteInspirationPhoto() {
      this.promoteInspirationPhotoBusy = true
      try {
        const id = this.photo.id
        await this.$store.dispatch('photos/promoteInspiration', id)
        EventBus.$emit('snackbar', {
          text: this.errorMessage
            ? this.errorMessage
            : "You've successfully voted to promote this photo to the Inspiration gallery",
          color: this.errorMessage ? 'info' : 'success'
        })
        await this.$auth.fetchUser()
      } catch (error) {
        this.$asa.appInsights('Comp: photo/Actions.vue - method: promoteInspirationPhoto', error)
      } finally {
        this.promoteInspirationPhotoBusy = false
      }
    },
    async promoteUpcomingPhoto() {
      this.promoteUpcomingPhotoBusy = true
      try {
        const id = this.photo.id
        await this.$store.dispatch('photos/promotePrime', id)
        EventBus.$emit('snackbar', {
          text: this.errorMessage
            ? this.errorMessage
            : "You've successfully promoted this photo to the Prime gallery",
          color: this.errorMessage ? 'info' : 'success'
        })
        await this.$auth.fetchUser()
      } catch (error) {
        this.$asa.appInsights('Comp: photo/Actions.vue - method: promoteUpcomingPhoto', error)
      } finally {
        this.promoteUpcomingPhotoBusy = false
      }
    },
    reportPhoto() {
      displayConfirm(
        'You are going to report this photo because you think it contains one of the following: porn, racism or offensive content. By clicking continue you will be flagging this photo to the admin attention.',
        async result => {
          if (result.isConfirmed) {
            try {
              await this.$store.dispatch('photos/reportPhoto', this.photo.id)
              EventBus.$emit('snackbar', {
                text: 'The photo has been successfully reported',
                color: 'success'
              })
            } catch (error) {
              this.$asa.appInsights('Comp: photo/Actions.vue - method: reportPhoto', error)
            }
          }
        }
      )
    },
    removePhoto() {
      displayConfirm(
        'Are you sure you wish to delete this photo? This action cannot be undone!',
        async result => {
          if (result.isConfirmed) {
            try {
              await this.$store.dispatch('photos/removePhoto', this.photo.id)
              EventBus.$emit('snackbar', {
                text: 'The photo has been successfully removed',
                color: 'success'
              })
              await this.$auth.fetchUser()
              this.goBack()
            } catch (error) {
              this.$asa.appInsights('Comp: photo/Actions.vue - method: removePhoto', error)
            }
          }
        }
      )
    }
  }
}
</script>
